import(/* webpackMode: "eager" */ "/var/www/businessstorepro/app/src/app/error.tsx");
